<template>
  <div
    :class="$b({
      'cross-sell-rating': crossSellMode,
      'review-mode': reviewMode,
      'header-mode': headerMode,
      'inline': inline,
      gradientLight,
      comparisonMode
    })"
  >
    <div
      v-for="(star, i) in stars"
      :key="i"
      :class="$b('star', { size })"
    >
      <div :class="$b('empty-star')" />
      <div
        :class="$b('full-star')"
        :style="{ width: `${star * 100}%` }"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'StarRatings',

  props: {
    rating: {
      type: Number,
      default: 5
    },
    crossSellMode: { type: Boolean, default: false },
    reviewMode: { type: Boolean, default: false },
    headerMode: { type: Boolean, default: false },
    inline: { type: Boolean, default: false },
    gradientLight: { type: Boolean, default: false },
    comparisonMode: { type: Boolean, default: false },
    size: {
      type: String,
      default: '',
      validator: str => ['', 'base', 'sm', 'md', 'lg', 'xl'].includes(str)
    }
  },

  computed: {
    stars () {
      return [...Array(5)].map(
        (_, idx) => Math.min(
          Math.max(this.rating - idx, 0), 1
        )
      )
    }
  }
}
</script>

<style lang="postcss">
  .StarRatings {
    @apply align-middle
      inline-block
      overflow-hidden
      relative
      whitespace-nowrap
      text-grey;

    &--comparison-mode {
      @apply flex flex-row items-center font-normal;
    }
  }

  .StarRatings__star {
    @apply inline-block
      relative;
    font-size: 30px;
    height: 30px;
    width: 30px;

    &--size-sm {
      font-size: theme('fontSize.sm');
      height: theme('fontSize.sm');
      width: theme('fontSize.sm');
    }

    &--size-base {
      font-size: theme('fontSize.base');
      height: theme('fontSize.base');
      width: theme('fontSize.base');
    }

    &--size-md {
      font-size: theme('fontSize.md');
      height: theme('fontSize.md');
      width: theme('fontSize.md');
    }

    &--size-lg {
      font-size: theme('fontSize.lg');
      height: theme('fontSize.lg');
      width: theme('fontSize.lg');
    }

    &--size-xl {
      font-size: theme('fontSize.xl');
      height: theme('fontSize.xl');
      width: theme('fontSize.xl');

      @screen xxsMax {
        font-size: theme('fontSize.lg');
        height: theme('fontSize.lg');
        width: theme('fontSize.lg');
      }
    }
  }

  .StarRatings__full-star {
    @apply absolute left-0 top-0
      h-full
      overflow-hidden;

    &:before {
      @apply absolute left-0 top-0
        bg-clip-text
        overflow-hidden
        text-transparent
        whitespace-nowrap;
      content: "\2605";
      line-height: 1.2;
      background-image: var(--gradient);
    }

    .StarRatings--gradient-light & {
      &:before {
        background-image: var(--gradient-light);
      }
    }
  }

  .StarRatings__empty-star {
    &:before {
      @apply absolute left-0 top-0;
      content: "\2605";
      line-height: 1.2;
    }
  }

  .StarRatings--cross-sell-rating {
    padding-top: 4px;
  }

  .StarRatings--review-mode {
    .StarRatings__star {
      @apply text-lg;
      height: theme('fontSize.lg');
      width: theme('fontSize.lg');
    }
  }

  .StarRatings--header-mode {
    .StarRatings__star {
      @screen mdMax {
        font-size: theme('fontSize.lg');
        height: theme('fontSize.lg');
        width: theme('fontSize.lg');
      }
    }
  }
</style>
